import Vue from 'vue'
import axios from '@/http-common'

import { LIQUIDACIONES_REQUEST, LIQUIDACIONES_ERROR, LIQUIDACIONES_SUCCESS } from '../actions/liquidaciones'
import { LIQUIDACION_RESUMEN_REQUEST, LIQUIDACION_RESUMEN_ERROR, LIQUIDACION_RESUMEN_SUCCESS } from '../actions/liquidaciones'
import { LIQUIDACION_DETALLE_REQUEST, LIQUIDACION_DETALLE_ERROR, LIQUIDACION_DETALLE_SUCCESS } from '../actions/liquidaciones'
import { AUTH_LOGOUT } from '../actions/auth'

const state = { 
  status: '', 
  liquidaciones: [],
  resumen_liquidacion: [],
  detalle_liquidacion: [],
  idLiquidacionCargada: 0,
  idTipoGastoIngresoCargado: 0
}

const getters = {
  liquidacionCargada(state) {
    var liquidacionCargada = state.liquidaciones.find(liquidacion => liquidacion.IDLIQUIDACION == state.idLiquidacionCargada)

    if (liquidacionCargada) 
      return liquidacionCargada.CONCEPTO
  },
  resumenLiquidacionCargado(state) {
    var resumenCargado = state.resumen_liquidacion.find(resumen => resumen.IDTIPO_GASTO_INGRESO == state.idTipoGastoIngresoCargado)

    if (resumenCargado)
      return resumenCargado.DESC_TIPO_GASTO_INGRESO
  }
}

const actions = {
  [LIQUIDACIONES_REQUEST]: ({commit}, payload) => {
    commit(LIQUIDACIONES_REQUEST)
    axios.get('/liquidaciones?idcomunidad=' + payload.idComunidad , {})
      .then(response => {
        commit(LIQUIDACIONES_SUCCESS, response.data)
      })
      .catch(() => {
        commit(LIQUIDACIONES_ERROR)
      })
  },
  [LIQUIDACION_RESUMEN_REQUEST]: ({commit}, payload) => {
    commit(LIQUIDACION_RESUMEN_REQUEST)
    axios.get('/liquidaciones/' + payload.idLiquidacion + '/resumen' , {})
      .then(response => {
        commit(LIQUIDACION_RESUMEN_SUCCESS, { 
          idLiquidacion: payload.idLiquidacion,
          data: response.data
        })
      })
      .catch(() => {
        commit(LIQUIDACION_RESUMEN_ERROR)
      })
  },
  [LIQUIDACION_DETALLE_REQUEST]: ({commit}, payload) => {
    commit(LIQUIDACION_DETALLE_REQUEST)
    axios.get('/liquidaciones/' + payload.idLiquidacion + '/detalles?idtipo_gasto_ingreso=' + payload.idTipoGastoIngreso , {})
      .then(response => {
        commit(LIQUIDACION_DETALLE_SUCCESS, {
          idTipoGastoIngreso: payload.idTipoGastoIngreso,
          data: response.data
        })
      })
      .catch(() => {
        commit(LIQUIDACION_DETALLE_ERROR)
      })
  }
}

const mutations = {
  [LIQUIDACIONES_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [LIQUIDACIONES_SUCCESS]: (state, resp) => {
    state.status = 'success'
    
    Vue.set(state, 'liquidaciones', resp)
    Vue.set(state, 'detalle_liquidacion', [])
    Vue.set(state, 'resumen_liquidacion', [])
  },
  [LIQUIDACIONES_ERROR]: (state) => {
    state.status = 'error'
  },

  [LIQUIDACION_RESUMEN_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [LIQUIDACION_RESUMEN_SUCCESS]: (state, payload) => {
    state.status = 'success'
    state.idLiquidacionCargada = payload.idLiquidacion
    state.idTipoGastoIngresoCargado = 0

    Vue.set(state, 'resumen_liquidacion', payload.data)
    Vue.set(state, 'detalle_liquidacion', [])
  },
  [LIQUIDACION_RESUMEN_ERROR]: (state) => {
    state.status = 'error'
  },

  [LIQUIDACION_DETALLE_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [LIQUIDACION_DETALLE_SUCCESS]: (state, payload) => {
    state.status = 'success'
    state.idTipoGastoIngresoCargado = payload.idTipoGastoIngreso
    
    Vue.set(state, 'detalle_liquidacion', payload.data)
  },
  [LIQUIDACION_DETALLE_ERROR]: (state) => {
    state.status = 'error'
  },

  [AUTH_LOGOUT]: (state) => {
    state.idLiquidacionCargada = 0
    state.idTipoGastoIngresoCargado = 0
    state.liquidaciones = []
    state.resumen_liquidacion = []
    state.detalle_liquidacion = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
